import React from 'react';
import * as Icons from '@mui/icons-material';

const IconComponent = ({ name }: { name: string }) => {
  const Icon = Icons[name as keyof typeof Icons];
  return Icon ? <Icon /> : null;
};

export default IconComponent;